module.exports = __webpack_public_path__ + "static/media/select_arrow.a4199a79.svg";